import { render, staticRenderFns } from "./guimo.vue?vue&type=template&id=3280e418&scoped=true"
import script from "./guimo.vue?vue&type=script&lang=js"
export * from "./guimo.vue?vue&type=script&lang=js"
import style0 from "./guimo.vue?vue&type=style&index=0&id=3280e418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280e418",
  null
  
)

export default component.exports